<div class="form-row">
  <div class="col-12 col-md-6 label">{{ label | translate }}</div>
  <div class="col-12 col-md-6 value">
    <ng-content></ng-content>
  </div>
</div>
